import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import moment from "moment";

import { getUserData } from "utils/auth";

// MomentJS translations
import "moment/locale/de";
import "moment/locale/vi";
import "moment/locale/it";
import "moment/locale/fr";
import "moment/locale/ja";

// Translation files
import engResources from "locales/en";
import deResources from "locales/de";
import viResources from "locales/vi";
import itResources from "locales/it";
import frResources from "locales/fr";
import jpResources from "locales/jp";

export const SUPPORTED_LOCALES = ["en", "vi", "de", "it", "fr", "jp"];

const userLng = getUserData()?.locale;

// Set moment locale, globally
moment.locale(userLng || "en");

// For all options read https://www.i18next.com/overview/configuration-options
i18n
  .use(XHR) // load translation using http -> see /public/locales
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources: {
      en: engResources,
      de: deResources,
      vi: viResources,
      it: itResources,
      fr: frResources,
      jp: jpResources,
    },
    compatibilityJSON: "v3",
    lng: userLng || "en", // set default language to get rid of warnings https://github.com/i18next/react-i18next/issues/977#issuecomment-560389513
    fallbackLng: "en",
    debug: process.env.REACT_APP_ENV !== "production",

    ns: ["common"], // namespances to load initially without passing in withTranslation()
    defaultNS: "common", // default namespace used if not passed to translation function

    keySeparator: false, // we use content as keys
    nsSeparator: false, // we don't have nested namespace

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ",",
    },

    react: {
      wait: true,
    },
  });

export default i18n;
